import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueWechatTitle from 'vue-wechat-title'

Vue.config.productionTip = false

Vue.use(VueWechatTitle)
new Vue({
  render: h => h(App),
  router
}).$mount('#app')